import { Component, OnInit, Inject, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { LookupService } from 'src/app/Services/LookupService';
import { ILookupBase } from 'src/app/Models/ILookupBase';
import { saveAs } from 'node_modules/file-saver/src/FileSaver';
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { IReportRequest } from 'src/app/Models/IReportRequest';
import { ReportService } from 'src/app/Services/ReportService';
import { IReportPDF } from 'src/app/Models/IReportPDF';
import { Globals } from '../../../globals';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-_100_PSEdReportParameters',
  templateUrl: './_100_PSEdReportParameters.component.html',
  styleUrls: ['./_100_PSEdReportParameters.component.css']
})

export class _100_PSEdReportParametersComponent implements OnInit {

  _baseUrl: string;
  _myGlobals: Globals;

  date: Date; //datepicker
  //selectedValue: string = 'val1';  //radiobutton
  selectedPAU: SelectItem; selectedSite: SelectItem;//dropdown    
  //checkBoxPAU: string = 'val1'; checkBoxSite: string = 'val2';  //checkboxes
  _PAUid: string = null; _siteId: string = null;
  public showSpinner: boolean = false;

  //lookups
  lookupSite: any = [];
  lookupSiteName: string;
  lookupSiteAddress: string;
  lookupSiteList: ILookupBase[] = [{ value: null, label: "-- Select PAU to view sites --", shortText: null, updatedOn: null }];
  lookupPAUList: ILookupBase[] = [{ value: null, label: "-- NO PAUs --", shortText: null, updatedOn: null }];
  _lookupService: LookupService;
  _reportService: ReportService;

  constructor(lookupService: LookupService, reportService: ReportService, globals: Globals,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this._lookupService = lookupService;
    this._reportService = reportService;
    this._baseUrl = baseUrl;
    this._myGlobals = globals;
    this.date = new Date();
  }


  ngOnInit() {
    let today = new Date();
    this.date = new Date(today.getMonth() + 1 + '/' + today.getDate() + '/' + today.getFullYear());
    this.LoadLookupValues();
  }

  LoadLookupValues(): void {
    this._lookupService.getLookupPAUs(this._baseUrl + 'api/Lookup/GetLookupPauList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10))
      .subscribe((res: ILookupBase[]) => {
        if (!res || res.toString() === "") {
          this.lookupPAUList = [{ value: null, label: "-- NO PAUS ! --", shortText: null, updatedOn: null }]
        }
        else {
          this.lookupPAUList = [{ value: null, label: "-- ALL PAUs --", shortText: null, updatedOn: null }].concat(res);
          this.selectedPAU = this.lookupPAUList[0];
        }
        this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + '')
          .subscribe((res: ILookupBase[]) => {
            if (!res || res.toString() === "") {
              this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
            }
            else {
              this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
              this.selectedSite = this.lookupSiteList[0];
            }
          },
            err => console.error(err)
          );
      },
        err => console.error(err)
    );
  }

  LookupSites(id): void {
    this._PAUid = id.value;
    var param = (typeof id == "string") ? id : (id.value != null ? id.value : '');
    this._lookupService.getLookupSites(this._baseUrl + 'api/Lookup/GetLookupSiteList/' + this.date.toISOString().slice(0, 10) + '^' + this.date.toISOString().slice(0, 10) + '^' + param)
        .subscribe((res: ILookupBase[]) => {
          if (!res || res.toString() === "") {
            this.lookupSiteList = [{ value: null, label: "-- NO SITES TO VIEW ! --", shortText: null, updatedOn: null }]
          }
          else {
            this.lookupSiteList = [{ value: null, label: "-- All Sites --", shortText: null, updatedOn: null }].concat(res);
            this.selectedSite = this.lookupSiteList[0];
          }
        },
          err => console.error(err)
        );
  }

  setSite(id): void {
  this._siteId = id.value;
  }

  getSiteIdList(): string {
    if (this._siteId != null) { return this._siteId }
    else {
      let siteIdList: string;
      this.lookupSiteList.forEach((site, index, arr) => {
        if ((site.label != null) && (site.label != "-- Select PAU to view sites --") && (site.label != "-- NO SITES TO VIEW --")) {
          if (site.label != "-- All Sites --") siteIdList += site.value + '^';
        }
      });
      return siteIdList.slice(0, siteIdList.length - 1).replace('undefined', '');
    }
  }

  getSelectedDateData() {
    this.LoadLookupValues();
  }

  viewReport() {
    this.showSpinner = true;
    let reportParamArray: IReportParameter[] = [];
    var selectedPAUValue = this.lookupPAUList.find(x => x.value === this._PAUid).label;   
    var selectedSiteValue = this.lookupSiteList.find(y => y.value === this._siteId).label;
    
    reportParamArray.push(
      { parameterName: 'PAUName', parameterValue: (this.selectedPAU != null && selectedPAUValue != '-- ALL PAUs --') ? selectedPAUValue : 'All PAUs' },
      { parameterName: 'SiteName', parameterValue: (this.selectedSite != null && selectedSiteValue != '-- All sites --') ? selectedSiteValue.replace('-- ', '').replace(' --', '') : 'All Sites' },
      { parameterName: 'ExpandSites', parameterValue:/* this.checkBoxSite ?*/ 'S' /*: 'Not Expanded' */},
      { parameterName: 'ExpandDetails', parameterValue:/* this.checkBoxPAU ? */'D' /*: 'Not Expanded'*/ },
      { parameterName: 'SiteIdList', parameterValue: this.getSiteIdList().replace('undefined', '') },  
      { parameterName: 'AsOfDate', parameterValue: this.date.toISOString().slice(0, 10) },
      //{ parameterName: 'FormInstanceID', parameterValue: '' },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },   
      { parameterName: 'CustomWatermarkText', parameterValue: '' }
    );

    let now = new Date();
    let localReportFileName = '100-PossibleSpecialEdStatus_' + now.toISOString().slice(0, 10) + '_' + now.toTimeString().slice(0, 5) + '.pdf';
    let reportRequest = {} as IReportRequest;
    reportRequest.prefix = ' SpedXReports ';
    reportRequest.reportFileName = "Possible Special Ed Status";
    reportRequest.reportSpecificParameterArray = reportParamArray;
    
    this._reportService.getPDFReport(reportRequest).subscribe((res: IReportPDF) => {
      var binaryString = window.atob(res.base64FileContent);
      var stringLength = binaryString.length;
      var bytes = new Uint8Array(stringLength);
      for (var i = 0; i < stringLength; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      this.showSpinner = false;
      saveAs(new Blob([bytes], { type: 'application/pdf' }), localReportFileName);
    },
      err => {
        this.showSpinner = false;
        console.error(err);
      }
    );
  }

}
